import {
  GET_TRANSFERORDERS_REQUEST,
  GET_TRANSFERORDERS_SUCCESS,
  GET_TRANSFERORDERS_FAILURE,
  GET_SUIDS_REQUEST,
  GET_SUIDS_SUCCESS,
  GET_SUIDS_FAILURE,
  GET_AVAILABLEQTYFORTO_REQUEST,
  GET_AVAILABLEQTYFORTO_SUCCESS,
  GET_AVAILABLEQTYFORTO_FAILURE,
  DOWNLOAD_TRANSFER_ORDER_REQUEST,
  DOWNLOAD_TRANSFER_ORDER_SUCCESS,
  DOWNLOAD_TRANSFER_ORDER_FAILURE,
  GET_WAREHOUSES_BY_ITEM_ID_MOVEMENT_REQUEST,
  GET_WAREHOUSES_BY_ITEM_ID_MOVEMENT_SUCCESS,
  GET_WAREHOUSES_BY_ITEM_ID_MOVEMENT_FAILURE,
  GET_LEVEL1_BY_LEVEL_UPDATED_REQUEST,
  GET_LEVEL1_BY_LEVEL_UPDATED_SUCCESS,
  GET_LEVEL1_BY_LEVEL_UPDATED_FAILURE,
  GET_LEVEL2_BY_LEVEL_UPDATED_REQUEST,
  GET_LEVEL2_BY_LEVEL_UPDATED_SUCCESS,
  GET_LEVEL2_BY_LEVEL_UPDATED_FAILURE,
  GET_LEVEL3_BY_LEVEL_UPDATED_REQUEST,
  GET_LEVEL3_BY_LEVEL_UPDATED_SUCCESS,
  GET_LEVEL3_BY_LEVEL_UPDATED_FAILURE,
  GET_LEVEL4_BY_LEVEL_UPDATED_REQUEST,
  GET_LEVEL4_BY_LEVEL_UPDATED_SUCCESS,
  GET_LEVEL4_BY_LEVEL_UPDATED_FAILURE,
  SPLIT_QTY_REQUEST,
  SPLIT_QTY_SUCCESS,
  SPLIT_QTY_FAILURE,
} from "./transferOrderTypes";

const initialStateForAllTransferOrders = {
  loading: false,
  transferOrders: [],
  error: "",
};

const getAllTransferOrdersReducer = (
  state = initialStateForAllTransferOrders,
  action
) => {
  switch (action.type) {
    case GET_TRANSFERORDERS_REQUEST:
      return {
        ...state,
        loading: true,
      };
    case GET_TRANSFERORDERS_SUCCESS:
      return {
        loading: false,
        transferOrders: action.payload,
        error: "",
      };
    case GET_TRANSFERORDERS_FAILURE:
      return {
        loading: false,
        transferOrders: [],
        error: action.payload,
      };
    default:
      return state;
  }
};
const initialStateForWarehouse = {
  loading: false,
  warehouses: [],
  error: "",
};

const getWarehouseByItemCodeAndMovementReducer = (
  state = initialStateForWarehouse,
  action
) => {
  switch (action.type) {
    case GET_WAREHOUSES_BY_ITEM_ID_MOVEMENT_REQUEST:
      return {
        ...state,
        loading: true,
      };
    case GET_WAREHOUSES_BY_ITEM_ID_MOVEMENT_SUCCESS:
      return {
        loading: false,
        warehouses: action.payload,
        error: "",
      };
    case GET_WAREHOUSES_BY_ITEM_ID_MOVEMENT_FAILURE:
      return {
        loading: false,
        warehouses: [],
        error: action.payload,
      };
    default:
      return state;
  }
};

const initialStateForAllTransferOrdersDownload = {
  loading: false,
  transferOrders: [],
  error: "",
};

const getAllTransferOrdersDownloadReducer = (
  state = initialStateForAllTransferOrdersDownload,
  action
) => {
  switch (action.type) {
    case DOWNLOAD_TRANSFER_ORDER_REQUEST:
      return {
        ...state,
        loading: true,
      };
    case DOWNLOAD_TRANSFER_ORDER_SUCCESS:
      return {
        loading: false,
        transferOrders: action.payload,
        error: "",
      };
    case DOWNLOAD_TRANSFER_ORDER_FAILURE:
      return {
        loading: false,
        transferOrders: [],
        error: action.payload,
      };
    default:
      return state;
  }
};

const initialStateForSuids = {
  loading: false,
  suids: [],
  error: "",
};

const getSuidsReducer = (state = initialStateForSuids, action) => {
  switch (action.type) {
    case GET_SUIDS_REQUEST:
      return {
        ...state,
        loading: true,
      };
    case GET_SUIDS_SUCCESS:
      return {
        loading: false,
        suids: action.payload,
        error: "",
      };
    case GET_SUIDS_FAILURE:
      return {
        loading: false,
        suids: [],
        error: action.payload,
      };
    default:
      return state;
  }
};

const initialStateForAvailableQty = {
  loading: false,
  availableQty: {},
  error: "",
};

const getAvailableQtyForToReducer = (
  state = initialStateForAvailableQty,
  action
) => {
  switch (action.type) {
    case GET_AVAILABLEQTYFORTO_REQUEST:
      return {
        ...state,
        loading: true,
      };
    case GET_AVAILABLEQTYFORTO_SUCCESS:
      return {
        loading: false,
        availableQty: action.payload,
        error: "",
      };
    case GET_AVAILABLEQTYFORTO_FAILURE:
      return {
        loading: false,
        availableQty: {},
        error: action.payload,
      };
    default:
      return state;
  }
};

const initialStateForLevel1ByLevel = {
  loading: false,
  level1ByLevel: [],
  error: "",
};

const getLevel1ByLevelForTransferOrderReducer = (
  state = initialStateForLevel1ByLevel,
  action
) => {
  switch (action.type) {
    case GET_LEVEL1_BY_LEVEL_UPDATED_REQUEST:
      return {
        ...state,
        loading: true,
      };
    case GET_LEVEL1_BY_LEVEL_UPDATED_SUCCESS:
      return {
        loading: false,
        level1ByLevel: action.payload,
        error: "",
      };
    case GET_LEVEL1_BY_LEVEL_UPDATED_FAILURE:
      return {
        loading: false,
        level1ByLevel: [],
        error: action.payload,
      };
    default:
      return state;
  }
};

const initialStateForLevel2ByLevel = {
  loading: false,
  level2ByLevel: [],
  error: "",
};

const getLevel2ByLevelForTransferOrderReducer = (
  state = initialStateForLevel2ByLevel,
  action
) => {
  switch (action.type) {
    case GET_LEVEL2_BY_LEVEL_UPDATED_REQUEST:
      return {
        ...state,
        loading: true,
      };
    case GET_LEVEL2_BY_LEVEL_UPDATED_SUCCESS:
      return {
        loading: false,
        level2ByLevel: action.payload,
        error: "",
      };
    case GET_LEVEL2_BY_LEVEL_UPDATED_FAILURE:
      return {
        loading: false,
        level2ByLevel: [],
        error: action.payload,
      };
    default:
      return state;
  }
};

const initialStateForLevel3ByLevel = {
  loading: false,
  level3ByLevel: [],
  error: "",
};

const getLevel3ByLevelForTransferOrderReducer = (
  state = initialStateForLevel3ByLevel,
  action
) => {
  switch (action.type) {
    case GET_LEVEL3_BY_LEVEL_UPDATED_REQUEST:
      return {
        ...state,
        loading: true,
      };
    case GET_LEVEL3_BY_LEVEL_UPDATED_SUCCESS:
      return {
        loading: false,
        level3ByLevel: action.payload,
        error: "",
      };
    case GET_LEVEL3_BY_LEVEL_UPDATED_FAILURE:
      return {
        loading: false,
        level3ByLevel: [],
        error: action.payload,
      };
    default:
      return state;
  }
};

const initialStateForLevel4ByLevel = {
  loading: false,
  level4ByLevel: [],
  error: "",
};

const getLevel4ByLevelForTransferOrderReducer = (
  state = initialStateForLevel4ByLevel,
  action
) => {
  switch (action.type) {
    case GET_LEVEL4_BY_LEVEL_UPDATED_REQUEST:
      return {
        ...state,
        loading: true,
      };
    case GET_LEVEL4_BY_LEVEL_UPDATED_SUCCESS:
      return {
        loading: false,
        level4ByLevel: action.payload,
        error: "",
      };
    case GET_LEVEL4_BY_LEVEL_UPDATED_FAILURE:
      return {
        loading: false,
        level4ByLevel: [],
        error: action.payload,
      };
    default:
      return state;
  }
};

const initialStateForSplit = {
  loading: false,
  split: [],
  error: "",
};

const splitQtyReducer = (state = initialStateForSplit, action) => {
  switch (action.type) {
    case SPLIT_QTY_REQUEST:
      return {
        ...state,
        loading: true,
      };
    case SPLIT_QTY_SUCCESS:
      return {
        loading: false,
        split: action.payload,
        error: "",
      };
    case SPLIT_QTY_FAILURE:
      return {
        loading: false,
        split: [],
        error: action.payload,
      };
    default:
      return state;
  }
};

export {
  getAllTransferOrdersReducer,
  getSuidsReducer,
  getAvailableQtyForToReducer,
  getAllTransferOrdersDownloadReducer,
  getWarehouseByItemCodeAndMovementReducer,
  getLevel1ByLevelForTransferOrderReducer,
  getLevel2ByLevelForTransferOrderReducer,
  getLevel3ByLevelForTransferOrderReducer,
  getLevel4ByLevelForTransferOrderReducer,
  splitQtyReducer,
};
